module.exports = __webpack_public_path__ + "img/home_menu_shop120.e82b6c98.png";